import { IApplicationState } from 'app/types/types';
import { connect } from 'react-redux';
import { ITemplateHOCProps } from './types';
import { ITemplateEvents, ITemplateFields } from '../../components/Template/types';
import { Template } from '../../components/Template/Template';
import { onClick } from './events/onClick';
import { getSectionType } from '../../../../selectors/getSectionType';
import { ESettingsSectionType } from '../../../../../../base/components/SettingsSection/types';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: ITemplateHOCProps
): ITemplateFields => {
    const sectionType = getSectionType(state, boardId, null, 'allowCreateBoard');
    const isDisallow = sectionType === ESettingsSectionType.DISALLOW;
    const isShow = sectionType === ESettingsSectionType.DEFAULT || isDisallow;
    return {
        isDisallow,
        isShow,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId }: ITemplateHOCProps
): ITemplateEvents => {
    return {
        onClick: () => dispatch(onClick(boardId)),
    }
};

export const TemplateHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(Template);

TemplateHOC.displayName = 'TemplateHOC';
